import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

class SponsoredProductsBlock extends PureComponent {
  render() {
    const {
      activeView,
      productsGridRow,
      productsListRow
    } = this.props;

    return (
      <div className={`sponsored-products-block ${activeView === 'grid' ? 'grid' : 'list'}`}>
        <div>
          {activeView === 'grid' && (
            <div className={'sponsored-products__grid-wrapper'}>
              <div className={'sponsored-products-label'}>
                {this.props.sponsoredProductsLabel}
              </div>
              {productsGridRow}
            </div>
          )}
          {activeView === 'list' && (
            <>
              <div className={'sponsored-products-label'}>
                {this.props.sponsoredProductsLabel}
              </div>
              {productsListRow}
            </>

          )}
        </div>
      </div>
    );
  }
}

SponsoredProductsBlock.displayName = 'SponsoredProductsBlock';

SponsoredProductsBlock.propTypes = {
  productsGridRow: PropTypes.node.isRequired,
  productsListRow: PropTypes.node.isRequired,
  sponsoredProductsLabel: PropTypes.string,
  activeView: PropTypes.string
};

SponsoredProductsBlock.defaultProps = {
  sponsoredProductsLabel: 'Sponsored products',
  activeView: 'grid'
};

export default SponsoredProductsBlock;
